module.exports = __webpack_public_path__ + "static/img/idnQrUzQ.9cd5ac7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/horse-nest/idnQrUzQ.jpg
// module id = mp8Q
// module chunks = 7